import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SEMANTIC, UI } from '../../styles/theme';
import BackButton from '../common/BackButton';
import KycProgressBar from '../KycProgressBar';
import API from '../../api';

const FatcaQuestionnaire = () => {
  const [formData, setFormData] = useState({ isUsCitizen: '', hasUsResidency: '', hasTinNumber: '', tinNumber: '', birthCountry: 'IT', taxResidenceCountry: 'IT' });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');
  const { t } = useTranslation();

  const handleChange = (e) => { const { name, value } = e.target; setFormData({ ...formData, [name]: value }); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (formData.hasTinNumber === 'yes' && !formData.tinNumber) { setError(t('kyc.fatca.error_tin')); return; }
    try {
      await API.post('/kyc/fatca', { user_id: userId, ...formData });
      navigate('/kyc/contract-signature');
    } catch (err) {
      setError(t('kyc.fatca.error_save'));
    }
  };

  const radioGroupStyle = { display: 'flex', gap: UI.spacing.lg, marginTop: UI.spacing.sm };
  const radioLabelStyle = { display: 'flex', alignItems: 'center', gap: UI.spacing.sm, color: SEMANTIC.textPrimary, fontSize: UI.fontSize.md, cursor: 'pointer' };
  const inputStyle = { width: '100%', padding: UI.spacing.md, backgroundColor: SEMANTIC.backgroundCard, color: SEMANTIC.textPrimary, border: '1px solid rgba(255,255,255,0.15)', borderRadius: UI.borderRadius.sm, fontSize: UI.fontSize.md };
  const labelStyle = { color: SEMANTIC.textPrimary, display: 'block', marginBottom: UI.spacing.sm, fontSize: UI.fontSize.md, fontWeight: UI.fontWeight.bold };
  const questionBoxStyle = { backgroundColor: SEMANTIC.backgroundCard, padding: UI.spacing.lg, borderRadius: UI.borderRadius.sm, marginBottom: UI.spacing.lg, border: '1px solid rgba(255,255,255,0.08)' };

  const countryOptions = [
    { value: 'IT', label: t('kyc.fatca.country_IT') },
    { value: 'US', label: t('kyc.fatca.country_US') },
    { value: 'GB', label: t('kyc.fatca.country_GB') },
    { value: 'DE', label: t('kyc.fatca.country_DE') },
    { value: 'FR', label: t('kyc.fatca.country_FR') },
    { value: 'ES', label: t('kyc.fatca.country_ES') },
    { value: 'CH', label: t('kyc.fatca.country_CH') },
    { value: 'OTHER', label: t('kyc.fatca.country_OTHER') },
  ];

  return (
    <div style={{ backgroundColor: SEMANTIC.backgroundApp, minHeight: '100vh', display: 'flex', flexDirection: 'column', padding: UI.spacing.lg }}>
      <BackButton to="/kyc/privacy-consents" />
      <div style={{ maxWidth: '700px', margin: '0 auto', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: UI.spacing.xl }}>
          <img src={`${process.env.PUBLIC_URL}/Logo_Kuesto.png`} alt="Kuesto Logo" style={{ width: '120px' }} />
        </div>
        <KycProgressBar currentStep={8} totalSteps={10} />
        <div style={{ backgroundColor: SEMANTIC.backgroundCard, borderRadius: UI.borderRadius.md, padding: UI.spacing.xl, boxShadow: UI.shadow.card }}>
          <h2 style={{ color: SEMANTIC.actionBuy, marginBottom: UI.spacing.md, fontSize: UI.fontSize.title, fontWeight: UI.fontWeight.bold, textAlign: 'center' }}>{t('kyc.fatca.title')}</h2>
          <p style={{ color: SEMANTIC.textSecondary, marginBottom: UI.spacing.xl, textAlign: 'center', fontSize: UI.fontSize.md }}>{t('kyc.fatca.description')}</p>
          {error && (<div style={{ backgroundColor: 'rgba(255, 77, 77, 0.1)', border: `2px solid ${SEMANTIC.actionSell}`, borderRadius: UI.borderRadius.sm, padding: UI.spacing.md, marginBottom: UI.spacing.lg, color: SEMANTIC.actionSell, textAlign: 'center' }}>{error}</div>)}
          <form onSubmit={handleSubmit}>
            <div style={questionBoxStyle}>
              <label style={labelStyle}>{t('kyc.fatca.q1')}</label>
              <div style={radioGroupStyle}>
                <label style={radioLabelStyle}><input type="radio" name="isUsCitizen" value="yes" checked={formData.isUsCitizen === 'yes'} onChange={handleChange} required style={{ accentColor: SEMANTIC.actionBuy }} /> {t('kyc.fatca.yes')}</label>
                <label style={radioLabelStyle}><input type="radio" name="isUsCitizen" value="no" checked={formData.isUsCitizen === 'no'} onChange={handleChange} required style={{ accentColor: SEMANTIC.actionBuy }} /> {t('kyc.fatca.no')}</label>
              </div>
            </div>
            <div style={questionBoxStyle}>
              <label style={labelStyle}>{t('kyc.fatca.q2')}</label>
              <div style={radioGroupStyle}>
                <label style={radioLabelStyle}><input type="radio" name="hasUsResidency" value="yes" checked={formData.hasUsResidency === 'yes'} onChange={handleChange} required style={{ accentColor: SEMANTIC.actionBuy }} /> {t('kyc.fatca.yes')}</label>
                <label style={radioLabelStyle}><input type="radio" name="hasUsResidency" value="no" checked={formData.hasUsResidency === 'no'} onChange={handleChange} required style={{ accentColor: SEMANTIC.actionBuy }} /> {t('kyc.fatca.no')}</label>
              </div>
            </div>
            <div style={questionBoxStyle}>
              <label style={labelStyle}>{t('kyc.fatca.q3')}</label>
              <div style={radioGroupStyle}>
                <label style={radioLabelStyle}><input type="radio" name="hasTinNumber" value="yes" checked={formData.hasTinNumber === 'yes'} onChange={handleChange} required style={{ accentColor: SEMANTIC.actionBuy }} /> {t('kyc.fatca.yes')}</label>
                <label style={radioLabelStyle}><input type="radio" name="hasTinNumber" value="no" checked={formData.hasTinNumber === 'no'} onChange={handleChange} required style={{ accentColor: SEMANTIC.actionBuy }} /> {t('kyc.fatca.no')}</label>
              </div>
              {formData.hasTinNumber === 'yes' && (<div style={{ marginTop: UI.spacing.md }}><label htmlFor="tinNumber" style={labelStyle}>{t('kyc.fatca.tin_label')}</label><input type="text" id="tinNumber" name="tinNumber" value={formData.tinNumber} onChange={handleChange} placeholder={t('kyc.fatca.tin_placeholder')} style={inputStyle} /></div>)}
            </div>
            <div style={{ marginBottom: UI.spacing.lg }}>
              <label htmlFor="birthCountry" style={labelStyle}>{t('kyc.fatca.birth_country')}</label>
              <select id="birthCountry" name="birthCountry" value={formData.birthCountry} onChange={handleChange} required style={inputStyle}>
                <option value="">{t('kyc.fatca.select_default')}</option>
                {countryOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: UI.spacing.xl }}>
              <label htmlFor="taxResidenceCountry" style={labelStyle}>{t('kyc.fatca.tax_country')}</label>
              <select id="taxResidenceCountry" name="taxResidenceCountry" value={formData.taxResidenceCountry} onChange={handleChange} required style={inputStyle}>
                <option value="">{t('kyc.fatca.select_default')}</option>
                {countryOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
              </select>
            </div>
            <div style={{ backgroundColor: 'rgba(0, 255, 136, 0.05)', border: `1px solid ${SEMANTIC.actionBuy}`, borderRadius: UI.borderRadius.sm, padding: UI.spacing.md, marginBottom: UI.spacing.xl }}><p style={{ color: SEMANTIC.textSecondary, fontSize: UI.fontSize.sm, margin: 0 }}>{t('kyc.fatca.info_note')}</p></div>
            <button type="submit" style={{ width: '100%', padding: UI.spacing.md, backgroundColor: SEMANTIC.ctaPrimary, color: SEMANTIC.ctaPrimaryText, border: 'none', borderRadius: UI.borderRadius.sm, fontSize: UI.fontSize.lg, fontWeight: UI.fontWeight.bold, cursor: 'pointer' }}>{t('common.continue')}</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FatcaQuestionnaire;
